import RestService from "./RestService";

export default class PlaceService extends RestService {

    constructor() {
        super('places')
    }
}